import gql from 'graphql-tag'

export const createReviewMutation = gql`
  mutation createReview(
    $customerId: Int,
    $productId: Int!,
    $nickname: String!,
    $title: String!,
    $detail: String!,
    $ratingVotes: [RatingVoteInput]!,
    $captcha: String
  ) {
    createReview(
      input: {
        product_id: $productId,
        customer_id: $customerId,
        nickname: $nickname,
        title: $title,
        detail: $detail,
        rating_votes: $ratingVotes,
        captcha: $captcha
      }
    ) {
      success
      message
    }
  }
`
